"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderResultNotificationData = void 0;
const components_common_modals_1 = require("@hotelplan/components.common.modals");
const getOrderResultNotificationData = (success) => {
    if (success === true) {
        return {
            type: components_common_modals_1.NotificationType.SUCCESS,
            text: 'catalogs:orderResultNotification.success.text',
            title: 'catalogs:orderResultNotification.success.title',
        };
    }
    return {
        type: components_common_modals_1.NotificationType.ERROR,
        text: 'catalogs:orderResultNotification.error.text',
        title: 'catalogs:orderResultNotification.error.title',
    };
};
exports.getOrderResultNotificationData = getOrderResultNotificationData;
//# sourceMappingURL=fdr-catalogs-modals.utils.js.map